"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const react_1 = tslib_1.__importDefault(require("react"));
const react_moment_1 = tslib_1.__importDefault(require("react-moment"));
function TestEmailSendStatus({ approved, approvedSend, latestSend, testSends, }) {
    return (react_1.default.createElement("div", { className: "d-flex justify-content-start flex-row" },
        approved && approvedSend === latestSend && (react_1.default.createElement("div", { className: "flex-col-centered h-100" },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faCheckSquare, className: "mr-2 text-success d-inline", size: "2x" }))),
        ' ',
        react_1.default.createElement("div", { className: "flex-col-centered h-100 my-auto" },
            react_1.default.createElement("h5", { className: classnames_1.default('lead mb-0', approved ? 'text-success' : 'text-primary') }, approved && approvedSend === latestSend ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("strong", { className: "font-weight-bold" },
                    "Test email is approved",
                    ' '),
                react_1.default.createElement("span", null, "and is ready to be sent!"))) : (react_1.default.createElement("span", null,
                react_1.default.createElement("strong", { className: "font-weight-bold" },
                    "Test email #",
                    testSends.length),
                ' ',
                "sent",
                ' ',
                react_1.default.createElement(react_moment_1.default, { fromNow: true, className: "font-weight-bold" }, latestSend),
                ' ',
                "is awaiting approval..."))),
            ' ')));
}
exports.TestEmailSendStatus = TestEmailSendStatus;
//# sourceMappingURL=TestEmailSendStatus.js.map